<div id="container">
    <canvas id="intelligence-chart"></canvas>
</div>